import {mapGetters} from "vuex";

export default {
    computed: {
        ...mapGetters(['isExpandedSidebar']),
    },
    methods: {
        toggleWidget() {
            this.showWidget = !this.showWidget;
        },
    },
    watch: {
        isExpandedSidebar(v) {
            if (!v) {
                this.showWidget = false;
            }
        }
    },
    data() {
        return {
            showWidget: true,
            widgetStyles: {}
        }
    },
}
